<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(51,51,51,0.6)"
  size="medium"
  color="#ffff99"
  type="ball-clip-rotate-pulse"
  [fullScreen]="true">
</ngx-spinner>